import ParkingCard from './ParkingCard';

export default ParkingCard;